import React from "react";

import Widget from "./Widget";

const WidgetContainer = () => {
  return (
    <div className="h-screen flex items-center justify-center">
      <div className="max-w-md">
        <Widget />
      </div>
      <div className="fixed bottom-0 right-0 m-4 bg-black rounded-md px-2 py-1 text-white flex items-center">
        <a href="https://www.getprelaunchlist.com/?ref=hostedpage_badge">
          <span className="max-sm:text-xs">
            made with <strong className="max-sm:text-xs">prelaunchlist</strong>💜
          </span>
        </a>
      </div>
    </div>
  );
};

export default WidgetContainer;
